module.exports = __webpack_public_path__ + "2cdc2245799cc160832436772ec332e7.MP3";